exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Signika);", ""]);

// module
exports.push([module.id, ".container {\r\n        height: 100%;\r\n        display: -webkit-box;\r\n        display: -ms-flexbox;\r\n        display: flex;\r\n        -webkit-box-pack: center;\r\n            -ms-flex-pack: center;\r\n                justify-content: center;\r\n        /*align-items: center;*/\r\n        margin-top:30px;\r\n        font-family: Signika;\r\n}\r\n\r\n.instrucoes {\r\n        font-size: 18px;\r\n}\r\n\r\n.titulo-form {\r\n\r\n        color:black; \r\n        font-weight: bold; \r\n        font-size: 14px\r\n}\r\n\r\n.box-mensagem {\r\n        \r\n        padding: 10px 10px 10px 10px!important;\r\n}\r\n\r\n.box-form {\r\n\r\n        margin-top:0px; \r\n        margin-bottom:5px;\r\n}\r\n\r\n.form-label {\r\n\r\n        margin-bottom:0px;\r\n}\r\n\r\n.captcha {\r\n        display: inline-block; \r\n}\r\n\r\n.botao-enviar {\r\n        margin-top:20px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/contracheque-inativos/src/app/formulario/formulario.component.css
// module id = ../../../../../src/app/formulario/formulario.component.css
// module chunks = main